import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserPlus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 7,
			r: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 19,
			x2: 19,
			y1: 8,
			y2: 14
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 22,
			x2: 16,
			y1: 11,
			y2: 11
		})
	]
});
const ForwardRef = forwardRef(SvgUserPlus);
export default ForwardRef;
